import { createLogger } from "@/infra/logging/logger";

export const interstitialLog = createLogger("ADMOB");
